import { combineReducers } from "redux";
import AppState from "./AppState";
import { RESET_ALL_STATE } from "./RootActions";
import { ProductListReducer } from "./product-list/ProductListReducers";
import { ProductReducer } from "./product/ProductReducers";
import { StoreListReducer } from "./store-list/StoreListReducers";
import { CategoryReducer } from "./category/CategoryReducers";
import { CatalogListReducer } from "./catalog/CatalogReducers";
import { ModalReducer } from "./modal/ModalReducers";
import { OverlayReducer } from "./overlay/OverlayReducers";
import { FindProductsReducer } from "./find-products/FindProductsReducers";
import { globalAlertReducer } from "./global-alert/GlobalAlertReducers";
import { FacetReducer } from "./facets/FacetReducers";
import { UserReducer } from "./user/UserReducers";
import { ReportReducer } from "./report/ReportReducers";
import { BusinessRulesListReducer } from "./businessRules-list/BusinessRulesListReducers";
import { LoaderReducer } from "./loader/LoaderReducers";
import { AddProductCategoriesReducer } from "./add-product-categories/AddProductCategoriesReducer";
import { ProductCategoriesReducer } from "./remove-product-categories/RemoveProductCategoriesReducer";
import { AppConfigReducer } from "./app-config/AppConfigReducers";
import { VariationManagementReducer } from "./variation-management/VariationManagementReducers";
import { ClipBoardReducer } from "./clipboard/ClipBoardReducers";
import { ColorManagementReducer } from "./color-management/ColorManagementReducers";
import { LeadingImageReducer } from "./leading-image/LeadingImageReducer";
import { SocialAnalyticsReducer } from "./product-social-analytics/SocialAnalyticsReducers";
import { AdapterConfigReducer } from "./adapter-config/AdapterConfigReducers";
import { ProductAlertsListReducer } from "./product-alerts-modal/ProductAlertsListReducers";
import { ProductAlertsScheduleReducer } from "./product-alerts-schedule-modal/ProductAlertsScheduleReducers";
import { ProductClusterListReducer } from "./ai-cluster/AiClusterReducers";
import { ProductBadgeReducer } from "./product-badge/ProductBadgeReducers";
import { precachingCrawlerReducer } from "./precaching-crawler/PrecachingCrawlerReducer";
import { RecommendationProductsListReducer } from "./recommendations/RecommendationReducers";
import { ProductGroupComponentsReducer } from "./product-group/ProductGroupComponentsReducers";
import { LinkedCategoriesReducer } from "./linked-categories/LinkedCategoriesReducers";
import { SyncCategoriesReducer } from "./sync-categories/SyncCategoriesReducers";
import { PerformanceReportReducer } from "./performance-report/PerformanceReportReducers";
import { KpiConfigReducer } from "./kpi-config/KpiConfigReducers";
import { snackbarReducer } from "./snackbar/SnackbarReducers";
import { HeatMapReducer } from "./heatmap/HeatMapReducers";
import { SearchReindexReducer } from "./search-reindex/SearchReindexReducers";

const appReducer = combineReducers<AppState>({
  productList: ProductListReducer,
  products: ProductReducer,
  stores: StoreListReducer,
  catalog: CatalogListReducer,
  category: CategoryReducer,
  modal: ModalReducer,
  globalAlert: globalAlertReducer,
  overlay: OverlayReducer,
  findProducts: FindProductsReducer,
  facets: FacetReducer,
  user: UserReducer,
  report: ReportReducer,
  businessRulesList: BusinessRulesListReducer,
  loader: LoaderReducer,
  treeData: AddProductCategoriesReducer,
  productCategories: ProductCategoriesReducer,
  appConfig: AppConfigReducer,
  variationManagement: VariationManagementReducer,
  clipBoard: ClipBoardReducer,
  colorManagementProductList: ColorManagementReducer,
  leadingImage: LeadingImageReducer,
  socialAnalytics: SocialAnalyticsReducer,
  adapterConfig: AdapterConfigReducer,
  productAlerts: ProductAlertsListReducer,
  productAlertsSchedule: ProductAlertsScheduleReducer,
  productsCluster: ProductClusterListReducer,
  productBadge: ProductBadgeReducer,
  precachingCrawler: precachingCrawlerReducer,
  recommendationProducts: RecommendationProductsListReducer,
  productGroupComponents: ProductGroupComponentsReducer,
  linkedCategories: LinkedCategoriesReducer,
  syncCategories: SyncCategoriesReducer,
  performanceReport: PerformanceReportReducer,
  kpiConfig: KpiConfigReducer,
  snackbar: snackbarReducer,
  heatmap: HeatMapReducer,
  searchReindex: SearchReindexReducer,
});

const rootReducer = (state: AppState | undefined, action: any): AppState => {
  if (action.type === RESET_ALL_STATE) {
    // Return undefined to reset all reducers to their initial state
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
